import { FilterOperator } from "api/api";
import { fetchOrganizations } from "api/fetchers/organizationList";
import { fetchOrganizationOne } from "api/fetchers/organizationOne";
import { mutateOrganizationDelete } from "api/mutations/organizationDelete";
import { mutateOrganizationOne } from "api/mutations/organizationOne";
import { DataProvider } from "react-admin";
import NotImplementedError from "reactAdmin/NotImplementedError";
import { mutateOrganizationCreate } from "api/mutations/organizationCreate";

const organizationDataProvider: DataProvider = {
    getList: async (resource, params) => {
        const result = await fetchOrganizations(
            {
                from: (params.pagination.page - 1) * params.pagination.perPage,
                to: params.pagination.page * params.pagination.perPage - 1,
            },
            [
                {
                    column: params.sort.field,
                    direction: params.sort.order === "DESC" ? "desc" : "asc",
                },
            ],
            Object.keys(params.filter).map((item) => {
                let operator: FilterOperator = "eq";
                let column = item;
                let value = params.filter[item];
                if (["name", "address.street", "address.addressLine2", "address.city", "address.state", "address.zipCode"].indexOf(item) >= 0) {
                    operator = "like";
                    value = `%${value}%`;
                }
                return {column, value, operator};
            })
        );
        return { data: result.data as any, total: result.metadata.count };
    },
    getOne: async (resource, params) => {
        const id =
            typeof params.id === "string" ? parseInt(params.id, 10) : params.id;
        const result = await fetchOrganizationOne(id);
        return { data: result as any };
    },
    getMany: async (resource, params) => {
        const result = await fetchOrganizations(
            {
                from: 0,
                to: 100,
            },
            undefined,
            [
                {
                    column: "id",
                    value: params.ids.map((item) => String(item)),
                    operator: "eq",
                },
            ]
        );
        return { data: result.data as any, total: result.metadata.count };
    },
    getManyReference: async (resource, params) => {
        params.filter[params.target] = params.id;
        return organizationDataProvider.getList(resource, params)
    },
    create: async (resource, params) => {
        const result = await mutateOrganizationCreate(params.data);
        return { data: { id: result.data.id, ...params.data } as any };
    },
    update: async (resource, params) => {
        await mutateOrganizationOne(params.data);
        return { data: params.data as any };
    },
    updateMany: async (resource, params) => {
        throw NotImplementedError;
    },
    delete: async (resource, params) => {
        await mutateOrganizationDelete({
            id: typeof params.id === "string" ? parseInt(params.id, 10) : params.id,
        });
        return { data: params.previousData as any };
    },
    deleteMany: async (resource, params) => {
        for (let i = 0; i < params.ids.length; i++) {
            const id = params.ids[i];
            await mutateOrganizationDelete({
                id: typeof id === "string" ? parseInt(id, 10) : id,
            });
        }
        return { data: params.ids };
    },
};

export default organizationDataProvider;
